import { AccountSettings } from "01Data/Account";
import { AppContext } from "01Data/AppData";
import PageTemplate from "03AdminPages/00Templates/PageTemplate";
import { NoteText, PasswordPolicy } from "97Parts/Styles";
import { useSignal } from "99Tools/useModel";
import { Check } from "@mui/icons-material";
import { Checkbox, FormControlLabel, styled } from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { useContext, useState } from "react";

const ApplyButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

const ErrorText = styled("div")(({ theme }) => ({
  color: "#f00",
}));

const InfoText = styled("div")(({ theme }) => ({
  color: "#00f",
}));

const PasswordPageContents = () => {
  const a = useContext(AppContext).account;
  const [settings] = useState<AccountSettings>(new AccountSettings());
  const [showPwd, setShowPwd] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const redraw = useSignal();

  const handleChangePrev = (e: any) => {
    setInfoMessage("");
    setErrorMessage("");
    settings.passConfirm = e.target.value; // 再利用
    redraw();
  };

  const handleChangeNew = (e: any) => {
    setInfoMessage("");
    setErrorMessage("");
    settings.pass = e.target.value;
    redraw();
  };

  const handleShowPwd = (e: any) => {
    setInfoMessage("");
    setErrorMessage("");
    setShowPwd(e.target.checked);
  };

  const Apply = async () => {
    if (settings.pass !== "" && settings.passConfirm !== "") {
      await a.ChangePassword(settings.passConfirm, settings.pass);
    }
  };

  const handleApply = () => {
    Apply()
      .then(() => {
        setInfoMessage("変更が完了しました。");
      })
      .catch((err: any) => {
        console.error(err);
        setErrorMessage("変更処理が失敗しました。");
      });
  };

  return (
    <Paper sx={{ margin: { xs: "0", sm: "0 5% 0" }, padding: "5%" }}>
      <FormControl fullWidth>
        <NoteText style={{ marginTop: "10px" }}>パスワード</NoteText>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <TextField
            sx={{ width: "48%" }}
            type={showPwd ? "text" : "password"}
            variant="filled"
            margin="normal"
            id="passPrev"
            label="現在のパスワード"
            name="passPrev"
            onChange={handleChangePrev}
            inputProps={{ maxLength: 128 }}
            value={settings.passConfirm}
          />
          <TextField
            sx={{ width: "48%" }}
            type={showPwd ? "text" : "password"}
            variant="filled"
            margin="normal"
            id="passNew"
            label="新しいパスワード"
            name="passNew"
            onChange={handleChangeNew}
            inputProps={{ maxLength: 128 }}
            value={settings.pass}
          />
        </div>
        <PasswordPolicy>
          ※半角英大文字・半角英小文字・数字を含む、８文字以上のパスワードを設定してください。
        </PasswordPolicy>
        <FormControlLabel
          control={<Checkbox onChange={handleShowPwd} />}
          label="パスワードを表示します"
        />
        <ApplyButton
          startIcon={<Check />}
          variant="contained"
          color="primary"
          onClick={handleApply}
        >
          確定
        </ApplyButton>
        {errorMessage !== "" ? <ErrorText>{errorMessage}</ErrorText> : null}
        {infoMessage !== "" ? <InfoText>{infoMessage}</InfoText> : null}
      </FormControl>
    </Paper>
  );
};

const PasswordPage = () => {
  return (
    <PageTemplate title="パスワード変更">
      <PasswordPageContents />
    </PageTemplate>
  );
};

export default PasswordPage;
